// extracted by mini-css-extract-plugin
export default {"container":"vK-z","dimension":"wK-z","dimensionLabels":"xK-z"};